module.exports = __webpack_public_path__ + "img/visa_transparent.fb8df45f.svg";